import * as yup from 'yup';

export const formStatusSchema = yup.object().shape({
  status: yup.string(),
  note: yup.string().required('field_is_required_').trim(),
});
